export const customListSchemaFields = [{
        name: "description",
        title: "Descrizione",
    }];
